import { takeLatest } from 'redux-saga/effects';
import { environmentSaga } from './environment-saga';
import { spinnerSaga } from './spinner-saga';
import { commonSagaActionTypes } from '../../constants/actionTypes/commonActionTypes';
import { ssapSagaActionTypes } from '../../constants/actionTypes/ssapActionTypes';
import { dashboardLiteSagaActionTypes } from '../../constants/actionTypes/dashboardLiteActionTypes';

export default function* () {
    yield takeLatest(commonSagaActionTypes.GET_ENVIRONMENT, environmentSaga);
    yield takeLatest(Object.values(ssapSagaActionTypes), spinnerSaga);
    yield takeLatest(Object.values(dashboardLiteSagaActionTypes), spinnerSaga);
}